module.exports = __webpack_public_path__ + "img/guangzhoudongwuyuan.1cb943e6.png";